import axios from 'axios'
import { useAuthHeader, useAuthUser } from 'react-auth-kit'
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
// import AddButton from '../../usables/small/AddButton'
import Table from '../../usables/Table'
import Input from '../../usables/small/Input'
import Modal from '../../usables/Modal'
import Spinner from '../../usables/small/Spinner'
import ClosingAlert from '../../usables/Alert'

export default function  Guardians() {
  const auth  = useAuthHeader()
  const authUser  = useAuthUser()
  const [guardians, setGuardian] = useState([])
  const [dataLoaded, setDataLoaded] = useState({done: false, sucssess: false, items: 0})
  const [formData, setFormData] = useState({name: '', lastname: '', email: '', phone: ''})
  const [errorMsg, setErrorMsg] = useState('Nepavyko įrašyti reikšmės')
  const [showError, setShowError] = useState(false)

  const tableColumns = [{
    Header: "Globėjai",
    columns: [
      {
        Header: "Vardas",
        accessor: "person.name"
      },
      {
        Header: "Pavardė",
        accessor: "person.lastname"
      },
      {
        Header: "Telefonas",
        accessor: "person.phone"
      },
      {
        Header: "El. paštas",
        accessor: "person.email"
      },
      {
        Header: "Veiksmai",
        accessor: "action"
      }
    ]
  }]

  const config = {
    headers: {
      Authorization: auth()
    }
  }

  const createGuardian = () => {
    axios.post(process.env.REACT_APP_API + '/guardian', formData, config)
      .then((res)=>{
        if(res.status === 200){
          res.data.guardian.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/guardians/' + res.data.guardian.id}>Daugiau</Link>
          setGuardian(guardians => [res.data.guardian, ...guardians])
        }
      })
      .catch((err) => {
        setErrorMsg(err.response.data.message)
        setShowError(true)
      })
    }

  useEffect(() => {
    axios.get(process.env.REACT_APP_API + '/guardian', config)
    .then(res => {
      if(res.status === 200){
        //console.log(...res.data)
        setGuardian([]) //! Pašalinti prieš buildinant
        res.data.forEach((data) => {
          // console.log(data)
          data.action = <Link className='text-violet-500 hover:text-violet-700' to={'/dashboard/guardians/' + data.id}>Daugiau</Link>
          setGuardian(guardians => [...guardians, data])
          setDataLoaded({done: true, sucssess: true, items: res.data.length})
        })
      }
    })
    .catch(err => {
      setGuardian([]) //! Pašalinti prieš buildinant
      //console.log(err.response.data)
      setGuardian(guardians => [...guardians, err.response.data])
      setDataLoaded({done: true, sucssess: false, items: 0})
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <>
    <h2>Tėvai / globėjai</h2>
    <ClosingAlert type='error' message={errorMsg} show={showError} updateState={(value) => {setShowError(value)}} />
      {!dataLoaded.done
      ? <Spinner />
      : dataLoaded.sucssess
        ?dataLoaded.items
          ? <Table columns={tableColumns} data={guardians} />
          : <ClosingAlert type='warning' message='Globėjų nerasta' />
        : <ClosingAlert type='error' message='Kažkas nepavyko, bendykite vėl šiek tiek vėliau' />
      }
    {authUser().roles.admin &&
    <Modal showAddBtn={true} title='Naujas globėjas' saveText='Sukurti' submitFunction={() => createGuardian()}>
      <div className='pt-5'>
        <Input
          label='Vardas'
          name='name'
          type='text'
          value={formData.name}
          onChange={(e)=>setFormData({...formData, name: e.target.value})}
          />
        <Input
          label='Pavardė'
          name='lastname'
          type='text'
          value={formData.lastname}
          onChange={(e)=>setFormData({...formData, lastname: e.target.value})}
          />
        <Input
          label='El. paštas'
          name='email'
          type='email'
          value={formData.email}
          onChange={(e)=>setFormData({...formData, email: e.target.value})}
          />
        <Input
          label='Telefonas'
          name='phone'
          type='tel'
          value={formData.phone}
          onChange={(e)=>setFormData({...formData, phone: e.target.value})}
          />
        </div>
      </Modal>
}
    </>
  )
}